__webpack_require__.p = "https://next.slightning.site/";